// Necessary if using App Router to ensure this file runs on the client
"use client"

import { datadogRum } from "@datadog/browser-rum"

// Only enable in production
if (process.env.NEXT_PUBLIC_VERCEL_ENV === "production") {
  datadogRum.init({
    applicationId: "1d8499a7-098e-49de-9960-46e3d52cf86b",
    clientToken: "pub24b5f09e3b4fc0722cf8add996ad7383",
    // `site` refers to the Datadog site parameter of your organization
    // see https://docs.datadoghq.com/getting_started/site/
    site: "datadoghq.com",
    service: "nextjs",
    env: "production",
    version: process.env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_SHA,
    sessionSampleRate: 30,
    sessionReplaySampleRate: 10,

    defaultPrivacyLevel: "allow",

    // Specify URLs to propagate trace headers for connection between RUM and backend trace
    allowedTracingUrls: [
      { match: "https://paragraph.com/api", propagatorTypes: ["tracecontext"] },
      { match: "https://api.paragraph.com", propagatorTypes: ["tracecontext"] },
    ],
  })
}

export default function DatadogInit() {
  // Render nothing - this component is only included so that the init code
  // above will run client-side
  return null
}
